<template>
    <Card :document="document" />
</template>

<script>
import getDocument from '@/plugins/get-document';
import Card from '@/components/pages/card/Card.vue';

export default {
    components: {
        Card,
    },
    layout: 'site',
    async asyncData({$prismic, route, error}) {
        try {
            return await getDocument($prismic, route.path, error);
        }
        catch (e) {
            error({statusCode: 404, message: 'Not found'});
        }
    },
    head() {
        return {
            title: this.document.data.seo_title,
            meta: [
                {
                    hid: 'description',
                    name: 'description',
                    content: this.document.data.seo_description
                }
            ],
            link: [
                {
                    rel: 'canonical',
                    href: this.$prismic.linkResolver(this.document, true)
                }
            ].concat(this.hreflangs)
        };
    },
};
</script>
